import React from "react"

export const useClickNavElement = (callback) => {
	const handleClick = (e) => {
		if (e.target.tagName === "A" && e.target.href !== "") {
			callback()
		}
	}
	React.useEffect(() => {
		document.addEventListener("click", handleClick)
		return () => {
			document.removeEventListener("click", handleClick)
		}
	})
}
